$shm_hitalama_extension_app $shm_hitalama_app
	extension_content null
	auto /
		^ extension_auto /
	No_extension $mol_text
		text \
			\Выберите виджет-расширение
			\[ПКМ] - [Сделать chrome-расширением]
	Map_page $shm_hitalama_map_page
		entity <= map $shm_hitalama_map
		tools /
			<= Lights
	Rpc $mol_rpc_server
	Ext null
